import { TUTORIAL_CHAPTERS } from "../Widgets/SpotlightTutorial/tutorialRegistry";
import { getFirstStepId } from "../Widgets/SpotlightTutorial/tutorialEngine";
import { createStartedTutorialState, createResetTutorialState, saveOnboardingFields } from "./SpotlightTutorialService";

const nowIso = () => new Date().toISOString();

export const isChapterAvailableForUser = (chapter, userData) => !chapter.isEligible || chapter.isEligible({ userData });

const getChaptersBefore = (chapter) => TUTORIAL_CHAPTERS.slice(0, TUTORIAL_CHAPTERS.indexOf(chapter)).map((previous) => previous.id);

/**
 * Admin actions only ever write onboarding fields (saveOnboardingFields drops everything else), so account,
 * profile, Stripe, Registry and Event data can never be reset from here. Each action returns the written fields.
 */
export const restartTutorialForUser = async (user, { chapter, adminEmail }) => {
	const spotlightTutorial = createStartedTutorialState({
		chapterId: chapter.id,
		stepId: getFirstStepId(chapter),
		completedChapters: getChaptersBefore(chapter),
		previous: { createdAt: user.spotlightTutorial?.createdAt },
		extra: { autoNavigate: true, restartedAt: nowIso(), restartedBy: adminEmail },
	});
	const fields = { spotlightTutorial };
	await saveOnboardingFields(user.id, fields);
	return fields;
};

export const resetTutorialForUser = async (user, { adminEmail, askReferralAgain }) => {
	const fields = {
		spotlightTutorial: createResetTutorialState({ resetAt: nowIso(), resetBy: adminEmail }),
		...(askReferralAgain ? { referralPending: true } : {}),
	};
	await saveOnboardingFields(user.id, fields);
	return fields;
};